// extracted by mini-css-extract-plugin
export default {"diff":"changes-dialog_diff__SC-bn"};